import { useReducer } from "react";
import { ProviderProps } from "../types";
import { initialUserData, UserDataReducer } from "./Action";
import { UserDataContext, UserDataDispatchContext } from "./Context";

const UserDataStore: React.FC<ProviderProps> = ({children}) => {
    const [state, dispatch] = useReducer(UserDataReducer, initialUserData);

    return (
        <UserDataContext.Provider value={state}>
            <UserDataDispatchContext.Provider value={dispatch}>
                {children}
            </UserDataDispatchContext.Provider>
        </UserDataContext.Provider>
    )

}

export default UserDataStore;